import { useCurrentBrandPlan } from './queries/brandPlans/useCurrentBrandPlan'
import { useFlipperFlag } from './useFlipperFlag'

type Output = {
  showNextGenContentPreferences: boolean
  isLoading: boolean
}

export const useShowNextGenContentPreferences = (): Output => {
  const isNextGenContentPreferencesEnabled = useFlipperFlag('nextgen_content_preferences')
  const { data: brandPlan, isLoading } = useCurrentBrandPlan({ cacheTime: 1000 * 60 * 5, enabled: isNextGenContentPreferencesEnabled })
  const showNextGenContentPreferences = isNextGenContentPreferencesEnabled && !!brandPlan?.has_content_strategies

  return {
    showNextGenContentPreferences,
    isLoading
  }
}
